/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    verifyShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    orderBalance: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    subOrderId: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    isBaotingHuifu: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    cancle: function cancle() {
      this.$emit('closeConfirm');
    },
    confirmOrderMeal: function confirmOrderMeal() {
      this.$parent.dangebaoting(this.subOrderId, this.isBaotingHuifu);
    }
  },
  created: function created() {},
  mounted: function mounted() {}
};